var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-6 sm:py-8 md:py-12 lg:py-16 xl:py-20 bg-gray-700 text-gray-100"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }